import React from 'react';
import { Form, Input, TextArea } from 'semantic-ui-react';
import _startCase from 'lodash/startCase';
import { HIDDEN, SELECT, MULTI_SELECT } from './ContactFormInput.constants';
import { getSelectOptions } from './ContactFormInput.utils';
import { ContactFormFieldPropType } from '../ContactForm.propTypes';
var defaultProps = {
  error: false,
  disabled: false,
  showLabels: false,
  value: ''
};
export default function ContactFormInput(_ref) {
  var showLabels = _ref.showLabels,
    field = _ref.field,
    value = _ref.value,
    error = _ref.error,
    onChange = _ref.onChange,
    disabled = _ref.disabled;
  var label = field.label,
    displayLabel = field.displayLabel,
    placeholder = field.placeholder,
    type = field.type,
    required = field.required,
    options = field.options,
    inputType = field.inputType;
  var labelToDisplay = showLabels && (displayLabel || _startCase(label));
  if (type === HIDDEN) {
    // No UI element.
    return null;
  }
  if (type === SELECT) {
    var updatedOptions = getSelectOptions(options);
    return /*#__PURE__*/React.createElement(Form.Select, {
      disabled: disabled,
      error: error,
      required: required,
      key: label,
      name: label,
      label: labelToDisplay,
      placeholder: placeholder,
      value: value,
      labeled: false,
      options: updatedOptions,
      onChange: onChange
    });
  }
  if (type === MULTI_SELECT) {
    var _updatedOptions = getSelectOptions(options);
    return /*#__PURE__*/React.createElement(Form.Dropdown, {
      fluid: true,
      multiple: true,
      selection: true,
      disabled: disabled,
      error: error,
      required: required,
      key: label,
      name: label,
      label: labelToDisplay,
      placeholder: placeholder,
      value: value || [],
      labeled: false,
      options: _updatedOptions,
      onChange: onChange
    });
  }
  return /*#__PURE__*/React.createElement(Form.Field, {
    disabled: disabled,
    error: error,
    required: required,
    key: label,
    name: label,
    label: labelToDisplay,
    placeholder: placeholder,
    control: type === 'input' ? Input : TextArea,
    value: value,
    onChange: onChange,
    type: inputType || 'text'
  });
}
ContactFormInput.defaultProps = defaultProps;